<template>
	<div
		class="img-selector"
		:class="{ 'img-selector--vertical': verticalRefSize }"
	>
		<div
			class="img-selector__thumbnail"
			v-if="imgObj && imgObj.src"
			:style="{ maxWidth: thumbnailMaxWidth }"
		>
			<img
				class="img-selector__img"
				:src="imgObj && imgObj.src"
				ref="img"
				:style="imgStyle"
			/>
			<p class="img-selector__file-name" v-if="!updated && showFileName">
				{{ src.split('/').pop() }}
			</p>
			<button
				class="btn img-selector__cancel-btn"
				type="button"
				v-if="useCancel"
				@click="init"
			>
				{{ cancelBtnText }}
			</button>
			<button
				:class="[
					'btn-originalimage img-selector__origin-img-btn',
					{ 'img-selector__origin-img-btn--no-cancel': !useCancel },
				]"
				type="button"
				@click="viewOriginImg"
			></button>
		</div>
		<label class="btn img-selector__select" v-else>
			이미지 선택
			<input
				type="file"
				accept="image/*"
				ref="input"
				v-show="false"
				@change="fileChange"
			/>
		</label>
	</div>
</template>

<script>
	import util from '@/util.js';

	export default {
		name: 'ImgSelector',
		props: {
			thumbnailMaxWidth: {
				type: String,
				default: '300px',
			},
			limitByte: {
				type: Number,
				default: 0,
			},
			validation: {
				type: Function,
				default: () => true,
			},
			useCancel: {
				type: Boolean,
				default: true,
			},
			src: {
				type: String,
				default: '',
			},
			verticalRefSize: {
				type: Boolean,
				default: false,
			},
			thumbnailHeight: {
				type: Number,
				default: null,
			},
			showFileName: {
				type: Boolean,
				default: false,
			},
			cancelBtnText: {
				type: String,
				default: '취소',
			},
		},
		data() {
			return {
				imgObj: {
					src: this.src || '',
					extension: null,
					fileObj: null,
				},
				updated: false,
			};
		},
		computed: {
			imgStyle() {
				if (this.verticalRefSize && this.thumbnailHeight) {
					return {
						width: 'auto',
						height: `${this.thumbnailHeight}px`,
					};
				}
			},
		},
		watch: {
			src(src) {
				if (this.imgObj) {
					this.imgObj.src = src;
				} else {
					this.imgObj = { src };
				}
			},
		},
		updated() {
			this.updated = true;
		},
		methods: {
			init() {
				this.imgObj = null;
				this.$emit('change', this.imgObj);
			},
			fileChange(e) {
				try {
					this.$store.commit('toggleSpinner', true);
					const file = e.target.files[0];
					e.target.value = null;
					if (
						file.type !== 'image/jpeg' &&
						file.type !== 'image/png'
					) {
						alert('파일 포맷은 jpg, jpeg, png 만 가능합니다.');
						this.$store.commit('toggleSpinner', false);
						return;
					}
					const reader = new FileReader();
					const limitByte = this.limitByte;
					reader.onloadend = readerRes => {
						if (limitByte && readerRes.total > limitByte) {
							alert(
								`${Math.floor(limitByte / 1000)}KB이하의 사진을 등록하세요`
							);
							this.$store.commit('toggleSpinner', false);
							return;
						}
						const fileDir = readerRes.target.result;
						const imgObj = new Image();
						imgObj.onload = () => {
							if (!this.validation(imgObj)) {
								this.$store.commit('toggleSpinner', false);
								return;
							}
							this.imgObj = {
								src: fileDir,
								fileObj: file,
								extension: file.type.split('/').pop(),
							};
							this.$emit('change', this.imgObj);
						};
						imgObj.onerror = err => {
							console.error(err);
							alert(
								'이미지를 불러오는데 오류가 발생했습니다. 개발팀에 문의하세요.'
							);
						};
						imgObj.src = fileDir;
					};
					reader.onerror = err => {
						console.error(err);
						alert(
							'이미지를 불러오는데 오류가 발생했습니다. 개발팀에 문의하세요.'
						);
					};
					if (file) reader.readAsDataURL(file);
				} catch (err) {
					alert(err);
					console.error(err);
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			viewOriginImg() {
				util.popupImages([this.imgObj.src]);
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.img-selector {
		.img-selector__thumbnail {
			position: relative;
			text-align: right;
			font-size: 0;
		}

		.img-selector__img {
			width: 100%;
		}

		.img-selector__cancel-btn {
			margin-top: 12px;
		}

		.img-selector__origin-img-btn {
			position: absolute;
			right: 0;
			bottom: 42px;
		}

		.img-selector__origin-img-btn--no-cancel {
			bottom: 0;
		}

		.img-selector__select {
			cursor: pointer;
		}

		.img-selector--vertical {
			width: auto;

			.img-selector__img {
				display: block;
			}
		}

		.img-selector__file-name {
			position: absolute;
			bottom: 0;
			left: 0;
			margin-right: 60px;
			text-align: left;
			font-size: 0.875rem;
			word-break: break-all;
		}
	}
</style>
